<script>
import CoalStock3DView from "./CoalStock3DView.vue";

/**
 * 使用 render 挂载子组件，避免模板里 <coal-stock-3d-view /> 在部分构建/运行环境下
 * 未被识别为 Vue 组件而被当成原生空标签，导致整页模板不渲染。
 */
export default {
  name: "Stockmanagem3dIndex",
  render(h) {
    return h(CoalStock3DView);
  },
};
</script>
